import React from "react";
import Icon from "@material-ui/core/Icon";

import OilRigIcon from "features/planner/components/OilRigIcon";

export default ({ color }) => (
  <Icon>
    <OilRigIcon color={color} />
  </Icon>
);
